import { render, staticRenderFns } from "./ActivityReplyDrawer.vue?vue&type=template&id=afeb2746&scoped=true"
import script from "./ActivityReplyDrawer.vue?vue&type=script&lang=js"
export * from "./ActivityReplyDrawer.vue?vue&type=script&lang=js"
import style0 from "./ActivityReplyDrawer.vue?vue&type=style&index=0&id=afeb2746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afeb2746",
  null
  
)

export default component.exports